module.exports = __webpack_public_path__ + "img/60.f8fc8e41.jpg";